import * as React from 'react';

type Props = {
  /** Rendered size: 16px (`small`), 20px (`medium`) or 24px (`large`). Defaults to `small`. */
  size?: 'small' | 'medium' | 'large';
};

const sizeInPixels = {
  small: 16,
  medium: 20,
  large: 24,
} as const;

/**
 * The Recommendations Explainer's T-Rex glyph. We use our own icon to make it clear that this is a Coursera-specific feature, and to avoid confusion with the `@coursera/cds-icons` T-Rex glyph, which is used for the "Coursera Labs" product.
 *
 * @example
 * <IconButton icon={<TRexIcon size="small" />} aria-label={_t('Recommendations Explainer')} />
 */
const TRexIcon = ({ size = 'small' }: Props) => {
  const maskId = `trex-mask-${React.useId().replace(/:/g, '')}`;
  const iconSize = sizeInPixels[size];

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={iconSize}
      height={iconSize}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id={maskId}>
          <rect width="20" height="20" fill="#fff" />
          <ellipse cx="13.9" cy="4.05" rx="0.62" ry="0.88" fill="#000" />
          <path d="M14.7 6.35Q16.5 7.05 18.3 6.55" stroke="#000" strokeWidth="0.6" strokeLinecap="round" fill="none" />
          <path d="M16 6.75L16.35 7.35L16.75 6.85Z" fill="#000" />
        </mask>
      </defs>
      <path
        fill="currentColor"
        mask={`url(#${maskId})`}
        d="M5.92 18.06C5.74 17.59 5.74 15.96 5.92 15.36C6.10 14.74 6.17 14.78 3.66 13.86C3.09 13.65 2.22 13.10 1.73 12.65C0.43 11.45 0.53 10.92 1.99 11.25C3.35 11.56 4.32 11.18 5.62 9.79C6.93 8.41 7.83 7.88 9.17 7.72C10.10 7.60 10.10 7.60 10.13 5.80C10.16 2.60 11.84 1.08 14.44 1.88C16.28 2.44 18.15 3.22 18.54 3.58C19.45 4.43 19.50 6.71 18.60 6.63C17.85 6.57 17.29 6.67 17.29 6.88C17.29 6.99 17.57 7.08 17.92 7.08C18.40 7.08 18.54 7.18 18.54 7.49C18.54 8.18 17.75 8.54 16.23 8.54C14.62 8.54 14.37 8.73 14.22 10.08C14.14 10.82 14.20 11.08 14.56 11.43C15.09 11.96 15.11 12.15 14.66 12.52C14.38 12.75 14.29 12.74 14.07 12.44C13.71 11.95 13.64 11.98 13.09 12.86C12.79 13.35 12.59 14.00 12.58 14.58C12.57 15.10 12.49 15.77 12.40 16.08C12.27 16.55 12.35 16.74 12.82 17.14C13.53 17.75 13.39 18.03 12.32 18.20C10.43 18.50 9.92 18.07 9.94 16.20C9.95 14.95 9.48 14.86 8.65 15.95C8.08 16.70 8.08 16.70 8.55 17.19C9.31 18.01 8.98 18.33 7.40 18.33C6.46 18.33 6.00 18.25 5.92 18.06Z"
      />
    </svg>
  );
};

export default TRexIcon;
